var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconsChevronRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003A5D",
    d: "M14.683 12L9.24 5.65a1 1 0 111.518-1.3l6 7a.998.998 0 010 1.3l-6 7a1 1 0 11-1.518-1.3L14.683 12z"
  }))));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGcgZmlsbC1ydWxlPSJub256ZXJvIj4KICAgICAgICAgICAgPGc+CiAgICAgICAgICAgICAgICA8Zz4KICAgICAgICAgICAgICAgICAgICA8cGF0aCBkPSJNMCAwSDI0VjI0SDB6IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMTAwOCAtOTYxKSB0cmFuc2xhdGUoOTk2IDk0OSkgdHJhbnNsYXRlKDEyIDEyKSIvPgogICAgICAgICAgICAgICAgICAgIDxwYXRoIGZpbGw9IiMwMDNBNUQiIGQ9Ik0xNC42ODMgMTJMOS4yNCA1LjY1Yy0uMzYtLjQxOS0uMzExLTEuMDUuMTA4LTEuNDEuNDItLjM1OSAxLjA1LS4zMSAxLjQxLjExbDYgN2MuMzIxLjM3NC4zMjEuOTI2IDAgMS4zbC02IDdjLS4zNi40Mi0uOTkuNDY5LTEuNDEuMTEtLjQyLS4zNi0uNDY4LS45OTEtLjEwOC0xLjQxTDE0LjY4MyAxMnoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xMDA4IC05NjEpIHRyYW5zbGF0ZSg5OTYgOTQ5KSB0cmFuc2xhdGUoMTIgMTIpIi8+CiAgICAgICAgICAgICAgICA8L2c+CiAgICAgICAgICAgIDwvZz4KICAgICAgICA8L2c+CiAgICA8L2c+Cjwvc3ZnPgo=";
export { SvgIconsChevronRight as ReactComponent };